<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Checkout Pages
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-checkout-page'].isAllowed"
                    :to="{name: 'add-checkout-page'}"
                    class="btn btn-link">Add Checkout Page<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :tabs="gridTabs"
                    :provider="provider"
                    @completed="stopLoadingPage">
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no checkout pages</span>
                        <span slot="description">You can start accepting payments quickly by using checkout pages.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-checkout-page'].isAllowed"
                                :to="{name: 'add-checkout-page'}"
                                class="btn btn-link">Add Checkout Page<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import sessionStore from '@/common/storage/session-store';
    import cloningStoragekey from './cloning-storage-key';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';
    import checkoutPagesColumns from './checkout-pages-columns';

    export default {
        name: 'checkout-pages',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: checkoutPagesColumns({
                    onRowEdit: this.onRowEdit,
                    onRowClone: this.onRowClone,
                    onRowDelete: this.onRowDelete,
                }),
                gridTabs: new TabsConfiguration({
                    id: 'checkout-pages-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                        },
                    // TODO filtering and sorting currently broken for checkout pages API
                    ],
                    version: 1,
                }),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({checkoutPages}) => checkoutPages.getAll(params));
            },
            onRowEdit({rowData}) {
                this.$router.push({name: 'update-checkout-page', params: {id: rowData.fields.id}});
            },
            onRowClone({rowData}) {
                const {fields} = rowData.getJSON();
                Reflect.deleteProperty(fields, 'id');
                fields.name = null;
                fields.urlPathSegment = null;
                sessionStore.setItem(cloningStoragekey, fields);
                this.$router.push({name: 'add-checkout-page'});
            },
            async onRowDelete({rowData, grid}) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: `Delete ${this.$filters.unKebabCase(rowData.fields.name)}`,
                    content: `Are you sure you want to delete this checkout page? This action cannot be undone.`,
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    try {
                        grid.startLoading();
                        await this.$api(({checkoutPages}) => checkoutPages.delete({
                            id: rowData.fields.id,
                        }));
                        grid.fetchData();
                        this.$toast.positive('Checkout page successfully deleted');
                    } catch (error) {
                        this.$toast.fromError(error);
                        grid.stopLoading();
                    }
                }
            },
        },
    };
</script>
